"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XjbRechargeInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var XjbRechargeInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(XjbRechargeInit, _super);
    function XjbRechargeInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金宝充值页面初始化';
        _this.code = '106007';
        _this.desc = '现金宝充值页面初始化';
        _this.requestParams = new zl_1.XjbRechargeInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return XjbRechargeInit;
}(service_1.BaseService));
exports.XjbRechargeInit = XjbRechargeInit;
//# sourceMappingURL=xjbRechargeInit.js.map